import React from 'react';
import cx from 'clsx';

import { IconRcTick } from '@/assets';
import { IconRcStepLoading } from '@/assets/settings';
import './index.scss';

type StepProps = {
  index?: number;
  current?: number;
  loading?: boolean;
  title?: string;
  desc?: string;
};

export const Step = ({ index = 0, current = 0, loading, title, desc }: StepProps) => {
  return (
    <div
      className={cx('db-step', current === index && 'is-current', current > index && 'is-finish')}>
      <div className={cx('db-stepIcon')}>
        {current > index ? (
          <IconRcTick className="db-step-tickIcon" />
        ) : current === index && loading ? (
          <IconRcStepLoading />
        ) : (
          <div className="db-stepIcon is-number">{index + 1}</div>
        )}
      </div>
      <div className="db-stepContent">
        <div className="db-stepTitle">{title}</div>
        <div className="db-stepDesc">{desc}</div>
      </div>
    </div>
  );
};

export const Steps = ({
  current,
  loading,
  children,
  className,
}: {
  current?: number;
  loading?: boolean;
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cx('db-steps', className)}>
      {React.Children.map(children, (child, index) =>
        React.isValidElement(child)
          ? React.cloneElement(child as React.ReactElement<StepProps>, { current, loading, index })
          : null,
      )}
    </div>
  );
};
